import React, { useCallback } from 'react';
import Sticky from 'react-sticky-el';
import { Trans } from 'react-i18next';

import { APP_DNEVNIK, APP_CAFETERIA, APP_ACCESS } from 'app/common/constants/services';
import StudentsSelector from 'app/components/StudentsSelector';
import SettingsContainer from 'app/containers/SettingsContainer';
import i18n from 'app/i18n';

import Filter from './Filter';
import styles from './ChildEvents.scss';


type Props = {
  children: any,
  location: {
    pathname: string,
  },
  params: {
    type: string,
  },
  header: string,
  handleAllViewed: Function,
  unread?: number,
  notSticky: boolean,
  setNotSticky: Function,
  isParent: boolean,
  router: {
    push: (string) => void
  }
}

const filterChild = () => ([
  { string: 'all', title: i18n.t('subs:all') },
  { string: APP_CAFETERIA, title: i18n.t(`subs:${APP_CAFETERIA}`, { context: 'short' }) },
  { string: APP_DNEVNIK, title: i18n.t(`subs:${APP_DNEVNIK}`, { context: 'short' }) },
]);

const filterParent = () => ([
  { string: 'all', title: i18n.t('subs:all') },
  { string: APP_ACCESS, title: i18n.t(`subs:${APP_ACCESS}`, { context: 'short' }) },
  { string: APP_CAFETERIA, title: i18n.t(`subs:${APP_CAFETERIA}`, { context: 'short' }) },
  { string: APP_DNEVNIK, title: i18n.t(`subs:${APP_DNEVNIK}`, { context: 'short' }) },
]);

const ChildEvents = ({
  children,
  location: { pathname },
  params: { type, id },
  header,
  handleAllViewed,
  unread,
  notSticky,
  setNotSticky,
  isParent,
  router: { push },
}: Props) => {
  const url = pathname.split('/').slice(0, 3);
  const baseUrl = url.join('/');

  // TODO move to page
  const handleRedirectToAll = useCallback(() => {
    push(`${baseUrl}/all`);
  }, [baseUrl, push]);


  return (
    <div>
      <Sticky
        className={styles.sticky}
        onFixedToggle={setNotSticky}
      >
        <div className={styles.childrens}>
          <StudentsSelector />
        </div>
        <div className={styles.headerline}>
          <div className={styles.h2}>
            {header}
            {unread
              && <span>
                {' '}
                <Trans i18nKey="events:unread">
                  {'('}
                  <span className={styles.unread}>{{ unread }}</span>
                  {' не прочитанных)'}
                </Trans>
              </span>}
          </div>
          <div>
            <a href="viewed" onClick={handleAllViewed} className={styles.link}>
              <Trans i18nKey="events:mark_all_read">
                {'Пометить все как прочитанные'}
              </Trans>
            </a>
          </div>
          <div className={styles.settings}>
            <SettingsContainer dataKey="events" />
          </div>
        </div>

        <div className={styles.relative}>
          <Filter
            className={styles.filter}
            filter={isParent ? filterParent() : filterChild()}
            baseUrl={baseUrl}
            activeItem={type}
            studentId={parseInt(id, 10)}
            onInvalidActiveItem={handleRedirectToAll}
          />
        </div>

        {!notSticky && <div className={styles.shadow} />}

      </Sticky>

      <div className={styles.content}>
        {children}
      </div>
    </div>
  );
};

export default ChildEvents;
